import { api } from '@/lib/apiClient'

/** Generic GET for role portal dashboards / list endpoints */
export async function fetchPortalData(path: string, params?: Record<string, string | number | undefined>) {
  const { data } = await api.get(path, { params })
  return data.data as Record<string, unknown>
}

export async function postPortalData(path: string, payload?: Record<string, unknown> | FormData) {
  const { data } = await api.post(path, payload || {})
  return data as { ok?: boolean; success?: boolean; message?: string; error?: string; data?: Record<string, unknown> }
}

export async function fetchDeptAdminDashboard() {
  return fetchPortalData('/dept-admin/dashboard')
}

export async function fetchDeptAdminList(resource: string) {
  return fetchPortalData(`/dept-admin/${resource}`)
}
